import React from 'react';

const FollowUpFormModal = ({
  open,
  form,
  setForm,
  onClose,
  onSubmit,
  submitting = false,
  isEdit
}) => {
  if (!open) return null;

  const editing = typeof isEdit === 'boolean' ? isEdit : Boolean(form?.id);

  return (
    <div className="fixed inset-0 bg-black/40 z-[10050] flex items-center justify-center p-3">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl border border-slate-200">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
          <div>
            <h3 className="text-base font-semibold text-slate-900">{editing ? 'Edit Follow-up' : 'Create Follow-up'}</h3>
            <p className="text-[11px] text-slate-500">{editing ? 'Update the follow-up details' : 'Set the next follow-up details'}</p>
          </div>
          <button type="button" onClick={onClose} className="h-8 w-8 rounded-full border border-slate-200 text-slate-500 hover:bg-slate-50">
            <i className="bi bi-x"></i>
          </button>
        </div>
        <form onSubmit={onSubmit} className="px-4 py-3 space-y-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Call Status</label>
              <select
                value={form?.callStatus || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, callStatus: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              >
                <option value="">Call Status</option>
                <option value="answered">Answered</option>
                <option value="missed">Missed</option>
                <option value="busy">Busy</option>
                <option value="not_connected">Not Connected</option>
                <option value="invalid">Invalid</option>
                <option value="disconnected">Disconnected</option>
              </select>
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Outcome</label>
              <select
                value={form?.outcome || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, outcome: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
              >
                <option value="">Select Outcome</option>
                <option value="interested">Interested</option>
                <option value="not_interested">Not Interested</option>
                <option value="callback">Callback</option>
                <option value="no_answer">No Answer</option>
              </select>
            </div>
          </div>
          {form?.outcome === 'callback' && (
            <div>
              <label className="block text-[11px] font-semibold text-slate-600 mb-1">Next Follow-up Date & Time *</label>
              <input
                type="datetime-local"
                value={form?.nextFollowDateTime || ''}
                onChange={(e) => setForm((prev) => ({ ...prev, nextFollowDateTime: e.target.value }))}
                className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm bg-white"
                required
              />
            </div>
          )}
          <div>
            <label className="block text-[11px] font-semibold text-slate-600 mb-1">Note</label>
            <textarea
              rows="3"
              placeholder="Add follow-up notes..."
              value={form?.note || ''}
              onChange={(e) => setForm((prev) => ({ ...prev, note: e.target.value }))}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm"
            />
          </div>
          <div className="flex items-center justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="px-3 py-2 text-sm border border-slate-200 rounded-lg text-slate-600 hover:bg-slate-50">
              Cancel
            </button>
            <button type="submit" disabled={submitting} className="px-3 py-2 text-sm bg-[#009ef7] text-white rounded-lg disabled:opacity-60">
              {submitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FollowUpFormModal;
